<template>
  <el-container class="main-layout">
    <el-header class="main-header">
      <z-header></z-header>
    </el-header>
    <el-container>
      <el-aside class="main-aside">
        <z-nav-menu></z-nav-menu>
      </el-aside>
      <el-main class="main-content">
        <div class="page-title">
          <div class="left-text">
            <span class="el-icon-house"></span
            ><span class="home" @click="handleHome">首页</span
          ><span :class="{'home':writeIncomeFlag}" v-if="routerName !== '首页'" @click="handleBack"> >> {{
              routerName
            }}</span>

            <span v-if="writeIncomeFlag && stepName === 'first'"> >> {{ titleName }}</span>

          </div>
          <div class="right-btn">
            <span class="el-icon-close"></span>
          </div>
        </div>
        <div class="page-content">
          <router-view/>
        </div>
      </el-main>
    </el-container>
    <div class="footer">
      <span>当前操作单位:{{ company }}[</span>
      <span>{{ taxCode }}]</span>

    </div>
  </el-container>
</template>

<script>
import ZHeader from "@/components/z-header";
import ZNavMenu from "@/components/z-nav-menu";
import {mapMutations, mapState} from 'vuex';
import {moduleId} from '../store/modules/consolidated-income-tax-statement'
import UserPersistence from './../persistence/UserPersistence'

export default {
  components: {ZHeader, ZNavMenu},
  name: "main-layout",
  data() {
    return {
      company: UserPersistence.getCompany().name || UserPersistence.getCompany().orgName,
      taxCode: UserPersistence.getCompany().taxNum || UserPersistence.getCompany().taxCode
    }
  },
  computed: {
    routerName() {
      return this.$route.meta.title;
    },
    ...mapState(moduleId, {
      titleName: state => state.titleName,
      stepName: state => state.stepName,
      writeIncomeFlag: state => state.writeIncomeFlag
    })
  },
  methods: {
    ...mapMutations('app', [
      'setActiveMenu'
    ]),
    ...mapMutations(moduleId, [
      'setWriteIncomeFlag'
    ]),
    handleHome() {
      this.setActiveMenu('0')

      this.$router.push({
        path: "/home",
      });
    },
    handleBack() {
      this.setWriteIncomeFlag('')


    }
  },
  mounted() {


  },
};
</script>

<style lang="scss" scoped>
@import "../styles/baseConfig.scss";

.main-layout {
  height: 100%;
  position: relative;

  .main-header {
    height: 90px !important;
    color: #c8dbf6;
    background-color: $all-color;
  }

  .main-aside {
    width: 200px !important;
    border-right: #d1d3d8 solid 1px;
  }

  .main-content {
    background-color: #ffffff;
    padding: 0 !important;

    .page-title {
      height: 36px;
      line-height: 36px;
      padding-left: 10px;
      overflow: hidden;
      border-bottom: #d1d3d8 solid 1px;

      .left-text {
        .home {
          color: $all-color;
          padding: 0 5px;

          &:hover {
            color: #f56c6c;
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }

      .right-btn {
      }
    }

    .page-content {
      height: calc(100% - 37px);
    }
  }

  .footer {
    width: 100%;
    height: 20px;
    background-color: #eaedef;
    line-height: 20px;
    position: fixed;
    left: 0px;
    bottom: 1px;
    padding-left: 20px;
    font-size: 14px;


  }
}
</style>



// WEBPACK FOOTER //
// src/layout/main-layout.vue